<template>
  <div>
    <Header name="Indicação de Rede" titleLabel="Indicação de Rede" backRoute="/redecredenciada-home" />
    <omint-page-content>
      <template v-if="recommendations.length === 0">
        <OmtRow
          height="40px"
          border-radius="8px"
          bg="var(--colors-light-primary-navy-blue)"
          p="10px 15px 12px 8px"
          mb="24px"
        >
          <CFlex direction="row" align-items="center">
            <OmtIcons name="circle-exclamation" color="white" size="lg" min-width="14px" mr="8px" />
            <OmtTypography color="white" as="p2">Nenhum pedido de indicação de rede foi encontrado</OmtTypography>
          </CFlex>
        </OmtRow>

        <OmtCard bg="var(--colors-light-primary-light-gray)" border="none" p="11px 16px">
          <CFlex direction="column" align-items="top">
            <CBox mb="16px">
              <CFlex align="center">
                <OmtIcons mr="14px" size="xl" name="lightbulb" />
                <OmtTypography mt="11px" as="h2-bold" color="var(--colors-light-primary-gray1)">
                  Matenha seus endereços atualizados
                </OmtTypography>
              </CFlex>
            </CBox>
            <CBox>
              <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
                As indicações de rede são realizadas baseadas em seus endereços cadastrados. Matenha-os atualizados.
              </OmtTypography>
            </CBox>
          </CFlex>
        </OmtCard>
      </template>

      <template v-if="recommendations.some(r => r.Recente)">
        <OmtRow>
          <OmtTypography p="0px 0px 16px" as="h1-bold" color="var(--colors-light-primary-gray1)">
            Solicitação de indicação de rede
          </OmtTypography>
        </OmtRow>
        <OmtRow
          mb="16px"
          v-for="(recommendation, index) in recommendations.filter(r => r.Recente)"
          :key="index"
          @click="handleClick(recommendation)"
        >
          <OmtCard>
            <CFlex>
              <OmtIcons
                name="user-doctor"
                size="lg"
                color="var(--colors-light-primary-gray)"
                mr="16px"
                min-width="14px"
              />
              <CBox>
                <OmtTypography as="h3-semi-bold" mb="16px">{{ recommendation.DescricaoPedido }}</OmtTypography>
                <OmtTypography as="p2" mb="16px" color="var(--colors-light-primary-gray2)"
                  >{{ recommendation.DataPedido }} &middot; Protocolo: {{ recommendation.Protocolo }}</OmtTypography
                >
                <OmtDivider />
                <div class="card-status">
                  <div class="card-status-dot" :style="{ background: getCor(recommendation) }" />
                  <p class="card-status-label">{{ getText(recommendation) }}</p>
                </div>
              </CBox>
            </CFlex>
          </OmtCard>
        </OmtRow>
      </template>
      <template v-if="recommendations.some(r => !r.Recente)">
        <OmtRow>
          <OmtTypography p="8px 0px 16px" as="h2-bold" color="var(--colors-light-primary-gray1)">
            Indicações anteriores
          </OmtTypography>
        </OmtRow>
        <OmtRow
          mb="18px"
          v-for="(recommendation, index) in recommendations.filter(r => !r.Recente)"
          :key="index"
          @click="handleClick(recommendation)"
        >
          <OmtCard>
            <CFlex>
              <OmtIcons
                name="user-doctor"
                size="lg"
                color="var(--colors-light-primary-gray)"
                mr="16px"
                p="12px"
                min-width="14px"
              />
              <CBox>
                <OmtTypography as="h3-semi-bold" mb="16px">{{ recommendation.DescricaoPedido }}</OmtTypography>
                <OmtTypography as="p2" mb="16px" color="var(--colors-light-primary-gray2)"
                  >{{ recommendation.DataPedido }} &middot; Protocolo: {{ recommendation.Protocolo }}</OmtTypography
                >
                <OmtDivider />
                <div class="card-status">
                  <div class="card-status-dot" :style="{ background: getCor(recommendation) }" />
                  <p class="card-status-label">{{ getText(recommendation) }}</p>
                </div>
              </CBox>
            </CFlex>
          </OmtCard>
        </OmtRow>
      </template>

      <FixedButtonRow>
        <OmtButton :w="['100%', '308px !important']" mx="auto" @click="handleModalState">
          <OmtTypography as="h1-bold" color="white"> Solicitar nova indicação </OmtTypography>
        </OmtButton>
      </FixedButtonRow>
    </omint-page-content>
    <Footer />
    <AffiliateIndicationModal :isOpen="isModalOpen" @update:isOpen="handleModalState" />
  </div>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";
import InfoBox from "@/components/Molecules/InfoBox";
import Tile from "@/components/Organisms/AffiliateIndication/Tile";
import { CBox, CFlex, CList, CListItem } from "@chakra-ui/vue";
import { mapActions, mapState } from "vuex";
import OmtUppercase from "@/components/Atoms/omt-uppercase.vue";
import FloatingAddButton from "@/components/Molecules/FloatingAddButton";
import AffiliateIndicationModal from "@/components/Organisms/AffiliateIndication/AffiliateIndicationModal.vue";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

export default {
  name: "AffiliateIndicationVisualizeHome",
  components: {
    Footer,
    FloatingAddButton,
    Header,
    Tile,
    CList,
    CListItem,
    CBox,
    CFlex,
    InfoBox,
    OmtUppercase,
    AffiliateIndicationModal,
    FixedButtonRow
  },

  methods: {
    ...mapActions("affiliate", ["fetchRecommendationRequests", "fetchVerificaAps"]),
    handleClick(recommendations) {
      if (!recommendations?.Localizado) return;
      this.$router.push({
        name: "indication.details",
        params: { chamado: recommendations.ChamadoPedido }
      });
    },
    handleModalState(value) {
      if (this.isAps) {
        this.isModalOpen = value;
      } else {
        this.$router.push({
          path: "/indicacao-de-credenciados/criar-indicacao"
        });
      }
    },
    getCor(recommendation) {
      return recommendation.Localizado ? "var(--colors-light-support-success)" : "var(--colors-light-support-news)";
    },
    getText(recommendation) {
      return recommendation.Localizado ? "Solicitação respondida" : "Solicitação em análise";
    }
  },
  data() {
    return {
      recommendations: [],
      message: null,
      isModalOpen: false
    };
  },
  async mounted() {
    try {
      await this.$root.$emit("show-loading");

      const fetchedRecommendations = await this.fetchRecommendationRequests();

      if (!fetchedRecommendations || fetchedRecommendations.length === 0) {
        this.message = "Nenhum pedido de indicação de rede foi encontrado";
        return;
      }
      this.recommendations = fetchedRecommendations;
    } catch (error) {
      this.message = "Serviço temporariamente indisponível";
      console.error("Erro ao buscar recomendações:", error);
    } finally {
      await this.$root.$emit("hide-loading");
    }
    try {
      await this.fetchVerificaAps();
    } catch (error) {
      console.error("Erro ao verificar aps:", error);
    }
  },

  computed: {
    ...mapState("affiliate", ["isAps"])
  }
};
</script>
<style lang="scss" scoped>
.card {
  padding: var(--space-4);
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: #dadada;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &-icon {
    width: 36px;
  }

  &-status {
    display: flex;
    align-items: center;

    &-dot {
      background: var(--colors-light-support-success);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }
  &-status-label {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: var(--colors-light-primary-gray1);
  }
}
</style>
